// extracted by mini-css-extract-plugin
export default {"banner":"style_banner__7pxvp","description":"style_description__cjE-S"};